<template>
  <div id="manage">
    <div class="content">
        <div class="title">学员管理</div>
        <div class="top">
            <div class="fl_left">
                <div class="wzbarBox">
                    <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                        <div>{{name.name}}</div>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input
                        id="demo"
                        v-model="keyword"
                        icon="ios-search"
                        placeholder="学员姓名/联系电话/证件号"
                        style="width: 330px;height:34px;border:1px solid #e7e7eb;margin:20px 0;"
                        class="bradius"
                        @on-click="search(1)"
                        @keyup.enter.native="search(1)"
                        autocomplete="off"></Input>
                    </div>
                    <!-- <div class="fl_right addClass" @click="addRecruit">新增学员</div> -->
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">姓名</div>
                            <div class="fl_left inputBox">
                                <Input v-model="name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入学员姓名" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">性别</div>
                            <div class="fl_left inputBox">
                                <RadioGroup v-model="teatsex">
                                    <Radio label="1">男</Radio>
                                    <Radio label="0">女</Radio>
                                </RadioGroup>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">舞种</div>
                            <div class="fl_left inputBox">
                                <Select v-model="dance" class="bordiv" placeholder="请选择级别" filterable @on-change="getLvel(1)" style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in danceList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">级别</div>
                            <div class="fl_left inputBox">
                                <Select v-model="level_id" class="bordiv" placeholder="请选择级别" filterable style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">电话/登录账号</div>
                            <div class="fl_left inputBox">
                                <Input v-model="phone" class="bordiv" size="large" style="width:440px;" placeholder="请输入学员手机号" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>

                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
            <div class="alertBox" v-if="teaShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置</div>
                        <div class="fl_right tandel" @click="teadel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">选择级别</div>
                            <div class="fl_left inputBox" style="width: 450px;">
                                <!-- <Select v-model="level_ids" multiple class="bordiv" placeholder="请选择级别" filterable style="width:440px;margin-right:10px;height:72px;">
                                 <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select> -->
                                <!-- <Tree :data="danceLevelTree" show-checkbox :multiple="true" :select-node="true" ></Tree> -->
                                <el-tree
                                :data="danceLevelTree"
                                show-checkbox
                                node-key="id"
                                ref="danceLevelTree"
                                :default-checked-keys="treeSelect"
                                :props="defaultProps">
                                </el-tree>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="teayes">确定</div>
                </div>
            </div>
            <!-- 设置单位归属 -->
            <div class="alertBox" v-if="companyShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置单位归属</div>
                        <div class="fl_right tandel" @click="teadel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                        <Alert>设置归属承办单位，将会影响承办单位分成收入，请谨慎操作。</Alert>
                            <div class="fl_left name">选择单位</div>
                            <div class="fl_left inputBox">
                                <Select v-model="company_own_id" class="bordiv" placeholder="请选择单位" filterable style="width:440px;margin-right:10px;">
                                 <Option v-for="item in companyOwn" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="setUserAscription">确定</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                teaShow:false,
                level_ids:[],
                items:[
                    {
                        name:'已报学员',
                        type:0
                    },
                    {
                        name:'所有学员',
                        type:1
                    },
                ],
                num:0,
                name:'',
                keyword:'',
                level_id:'',
                searchData:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '学员',
                        align: 'center',
                        key: 'name',
                        width:230,
                        render: (h, params) => {
                            if(params.row.sex==1){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater==''?'static/imgs/logo@3x.png':params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'150px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'150px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/man.png) left center / 12px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.card_code),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.code_type==0?'【护照】':params.row.code_type==1?'【大陆身份证】':params.row.code_type==2?'【港澳身份证】':params.row.code_type==3?'【台湾居民来往通行证】':'')
                                    ])
                                ]);
                            }
                            else if(params.row.sex==0){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater==''?'static/imgs/logo@3x.png':params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'150px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'150px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/girl.png) left center / 10px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.card_code),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.code_type==0?'【护照】':params.row.code_type==1?'【大陆身份证】':params.row.code_type==2?'【港澳身份证】':params.row.code_type==3?'【台湾居民来往通行证】':'')
                                    ])
                                ]);
                            }
                        }
                    },
                    {
                        title: '归属承办单位',
                        align: 'center',
                        key: 'company_name',
                        renderHeader: (h, params) =>{
                            return h('div',{
                                attrs:{id:'elementId'}
                            },
                            [
                                h('Tooltip',
                                    {
                                      props: {
                                        placement: 'bottom',
                                        transfer: true
                                      }
                                    },
                                    [
                                        h('div',
                                            {
                                                style:{
                                                    cursor:'pointer',
                                                    width:'120px',
                                                }
                                            },
                                            [
                                                h('span','归属承办单位'),
                                                h('Icon', {
                                                    props: {
                                                        type: 'ios-information-circle'
                                                    },
                                                    style:{
                                                      color:'#facfcfc',
                                                      cursor: 'pointer',
                                                      marginRight: '5px',
                                                      fontSize:'18px'
                                                    },
                                                    on: {

                                                    }
                                                }),
                                            ]
                                        ),
                                        h('span',{
                                          slot:'content',
                                          style:{
                                            whiteSpace:'normal'
                                          }
                                        },'归属承办单位，将参与分成。')
                                    ]
                                )

                            ])
                        },
                        render: (h, params) => {
                            let _this = this;
                            let _color ="";
                            let _text ="";
                            if(params.row.company_name==''){
                                _text = '暂无归属';
                                _color = '#cccccc';
                            }else{
                                _text = params.row.company_name;
                                _color = '#000000';
                            }
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        color:_color,
                                        border:'none',
                                    },
                                    on:{
                                        click: () => {
                                                let _this = this;
                                                _this.user_id=params.row.user_id;
                                                _this.getCompany();

                                            }
                                    }
                                },_text),
                            ]);
                        }
                    },
                    {
                        title: '学历',
                        align: 'center',
                        key: 'education',
                    },
                    {
                        title: '毕业院校',
                        align: 'center',
                        key: 'school',
                    },
                    {
                        title: '专业',
                        align: 'center',
                        key: 'specialty',
                    },
                    {
                        title: '联系电话',
                        align: 'center',
                        key: 'phone',
                    },
                    {
                        title: '是否免费',
                        align: 'center',
                        key: 'uphone',
                        width:120,
                        renderHeader: (h, params) =>{
                            return h('div',{
                                attrs:{id:'elementId'}
                            },
                            [
                                h('Tooltip',
                                    {
                                      props: {
                                        placement: 'bottom',
                                        transfer: true
                                      }
                                    },
                                    [
                                        h('div',
                                            {
                                                style:{
                                                    cursor:'pointer',
                                                    width:'120px',
                                                }
                                            },
                                            [
                                                h('span','是否免费'),
                                                h('Icon', {
                                                    props: {
                                                        type: 'ios-information-circle'
                                                    },
                                                    style:{
                                                      color:'#facfcfc',
                                                      cursor: 'pointer',
                                                      marginRight: '5px',
                                                      fontSize:'18px'
                                                    },
                                                    on: {
                                                    }
                                                }),
                                            ]
                                        ),
                                        h('span',{
                                          slot:'content',
                                          style:{
                                            whiteSpace:'normal'
                                          }
                                        },'控制课件是否免费查看，选择级别提交后则代表该学员可以免费查看该级别的所有课件。')
                                    ]
                                )

                            ])
                        },
                        render: (h, params) => {
                            let _this = this;
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            this.setDanceLevel(params.row)
                                        }
                                    }
                                }, params.row.free_level.length>0 ? '已设置':'点击设置'),
                            ]);
                            /*return h('div',[
                                h('i-switch', {
                                    props: {
                                        value: params.row.is_free==1,
                                        size:'default',
                                    },
                                    nativeOn: {
                                        click:() => { //值发生了改变调用方法
                                            this.$axios.post('edituser',{user_id:params.row.user_id}).then(res=>{
                                                if(res.data.code==200){
                                                    this.data6=[];
                                                    this.search(0)
                                                    this.$Message.success('操作成功');
                                                 }
                                                 else{
                                                        this.$Message.error(res.data.message);
                                                        this.data6=[];
                                                        this.search(0)
                                                 }
                                            }).catch(function (error) {
                                              console.log(error);
                                            });
                                        }
                                    }
                                },
                                [
                                    h('span',{
                                        slot:'open',
                                        domProps:{
                                            innerHTML:'是'
                                        },
                                    }),
                                    h('span',{
                                        slot:'close',
                                        domProps:{
                                            innerHTML:'否'
                                        },
                                    })
                                ])
                            ]);*/
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let luder = {
                                                    "pageNum": this.pageNum,
                                                };
                                                luder = JSON.stringify(luder);
                                                localStorage.setItem("luder", luder);
                                                this.$router.push({
                                                    path:'/manager/user_mager/stu/stuList',
                                                    query:{
                                                        student_id:params.row.user_id,
                                                        student_name:params.row.name,
                                                    }
                                                })
                                            }
                                        }
                                    },'查看'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                tabId:0,
                companyShow:false,//归属单位
                companyOwn:[],//归属单位
                company_own_id:'' ,////归属单位
                danceLevelTree:[],
                treeSelect:[],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                }
            }
        },
        methods:{
            //设置舞种级别
            setDanceLevel(item){

                let _this=this;
                _this.danceLevelTree = [];
                _this.treeSelect = [];
                item.free_level.forEach(e=>{
                    e.issue_auth_list.forEach(r=>{
                        _this.treeSelect.push(e.dance_id+r.level_id);
                    });
                });

                _this.danceList.forEach(d=>{
                    let _tmp = {
                        id:d.id,
                        dance_id:d.id,
                        title:d.name,
                        children:[],
                    }
                    _this.levelList.forEach(t=>{
                        _tmp.children.push({
                            id:d.id+t.id,
                            level_id:t.id,
                            dance_id:d.id,
                            title:t.name
                        })
                    });
                    _this.danceLevelTree.push(_tmp);
                });
                _this.user_id   = item.user_id;
                _this.teaShow=true;
            },
            //获取承办单位
            getCompany(){
                let _this=this;
                _this.$axios.post('getcompanyscreen',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyOwn = res.data.data.list;
                        _this.companyShow = true;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //设置归属承办单位
            setUserAscription(){
                let _this=this;
                _this.$axios.post('setuserascription',{user_id:_this.user_id,company_id:_this.company_own_id}).then(res=>{
                    if(res.data.code==200){
                        _this.companyShow = false;
                        _this.search(0);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            teayes(){
                let _this=this;

                let  level_ids= _this.$refs.danceLevelTree.getCheckedNodes();

                let _tmp = [];
                level_ids.forEach(e=>{
                    if(!_tmp.hasOwnProperty(e.dance_id)){
                        _tmp[e.dance_id] = []
                    }
                    _tmp[e.dance_id].push(e.level_id);
                });
                let _level = [];
                _this.danceList.forEach(e=>{
                    if(_tmp.hasOwnProperty(e.id)){
                        _level.push({
                            dance_id:e.id,
                            level:_tmp[e.id]
                        })
                    }
                })
                _this.$axios.post('edituser',{
                    user_id:_this.user_id,
                    free_level:_level,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.teaShow=false;
                        _this.search(0);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });

            },
            teadel(){
                this.teaShow=false;
                this.companyShow=false;
            },
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.tabId=item.type;
                _this.search(1);
            },
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.name==''){
                    this.$Message.error('请输入学员姓名');
                }
                else if(_this.dance==''){
                    this.$Message.error('请选择舞种');
                }
                else if(_this.level_id==''){
                    this.$Message.error('请选择级别');
                }
                else if(_this.phone==''){
                    this.$Message.error('请输入手机号');
                }
                else if(pattern.test(_this.phone)==false){
                    this.$Message.error('手机号输错了');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addteacher',{
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            phone:_this.phone,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editteacher',{
                            teacher_id:_this.teacher_id,
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            phone:_this.phone,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getuserlist',{
                    keyword:_this.keyword,
                    page:_this.pageNum,
                    is_all:_this.tabId
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.name='';
                _this.dance='';
                _this.level_id='';
                _this.teatsex='0';
                _this.getprovince();
                _this.phone='';
                _this.alertShow=true;
            },
            getprovince(){
                let _this=this;
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        _this.dance=res.data.data[0].id;
                        _this.getLvel(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvel(index){
                let _this=this;
                _this.$axios.post('getlevellist',{is_course: 1}).then(res=>{
                    if(res.data.code==200){
                        _this.levelArr  = res.data.data;
                        _this.levelList = res.data.data;

                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },

            getDanceList(index){
                let _this=this;
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this;
            _this.search(1);
            _this.getDanceList();
            _this.getLvel(1);
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/user_mager/stu.vue